<template>
	<Popup
		v-model="selfDisplay"
		title="开通产品"
		confirmBtnText="开通"
		@confirmClick="handleConfirmClick"
	>
		<div v-loading="loading" style="padding: 15px;">
			<div class="base_form_row">
				<span class="b_label">产品</span>
				<div class="b_checkbox_group">
					<el-checkbox-group v-model="productIds" @change="handleCheckboxChange">
						<el-checkbox v-for="v in authProduct" :key="v.id" :label="v.id">{{ v.name }}</el-checkbox>
					</el-checkbox-group>
				</div>
			</div>
		</div>
	</Popup>
</template>

<script>
	import Api from '../../../../../api/index.js';
	import { mapState } from 'vuex';
	
	export default {
		model: {
			prop: 'display',
			event: 'changeDisplay'
		},
		props: {
			display: Boolean,
			products: {
				type: Array,
				required: true
			},
			uid: {
				type: String,
				required: true
			},
			code: {
				type: [Number, String],
				required: true
			},
			formId: {
				type: String,
				required: true
			}
		},
		mounted () {
			this.display && (this.selfDisplay = true);
		},
		data () {
			return {
				loading: false,
				selfDisplay: false,
				productIds: []
			}
		},
		computed: {
			...mapState([
				'authProduct'
			])
		},
		methods: {
			handleCheckboxChange () {
				var proIndex = this.productIds.indexOf(1),
					funIndex = this.productIds.indexOf(0);
				if (proIndex > -1 && funIndex > -1) {
					var minIndex = proIndex < funIndex ? proIndex : funIndex;
					this.productIds.splice(minIndex, 1);
				}
			},
			// 点击开通
			handleConfirmClick () {
				const that = this;
				that.loading = true;
				var requestData = {
					productIds: JSON.stringify(that.productIds),
					userPatientId: that.uid,
					uenterpriseId: that.formId
				};
				Api.openUserProduct(requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						that.$emit('updateProduct', res.data.message);
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			}
		},
		watch: {
			display (newValue) {
				this.selfDisplay = newValue;
			},
			selfDisplay (newValue) {
				this.$emit('changeDisplay', newValue);
				if (newValue) {
					this.productIds = this.products.map(v => {
						return v.id;
					});
				} else {
					this.loading = false;
					this.productIds = [];
				}
			}
		}
	}
</script>

<style>
</style>
